import PeopleIcon from '@material-ui/icons/People';
export const ClientIcon = PeopleIcon;

